import { render, staticRenderFns } from "./Association.vue?vue&type=template&id=24432a8c"
import script from "./Association.vue?vue&type=script&lang=js"
export * from "./Association.vue?vue&type=script&lang=js"
import style0 from "./Association.vue?vue&type=style&index=0&id=24432a8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports